module.exports = __webpack_public_path__ + "static/media/magnifying-glass-world.9d98fafe.svg";